import * as React from "react";
import { PropertyAmenityDescription as SharedUiPropertyAmenityDescription } from "@shared-ui/lodging-property-details";
import { RefTarget } from "@shared-ui/ref-context";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { UitkSpacing } from "uitk-react-spacing";

const WrappedPropertyAmenityDescription = PropertyBexApiWrapper(SharedUiPropertyAmenityDescription);

export const PropertyAmenityDescription: React.FC<ComponentProps> = ({ context }) => (
  <UitkSpacing margin={{ block: "three" }}>
    <RefTarget name="Amenities" tag="section">
      <WrappedPropertyAmenityDescription context={context} />
    </RefTarget>
  </UitkSpacing>
);

export default PropertyAmenityDescription;
